import { BusinessObjectBase } from './base';
import type { UserTask } from './user-task';

export interface UserTaskHistoryData {
  readonly id: string;
  readonly eventType: string;
  readonly data?: any;
  readonly timestamp?: Date;
  readonly userTaskId: number;
  readonly userTask?: UserTask;
}

export interface UserTaskHistory extends Readonly<UserTaskHistoryData> {}
export class UserTaskHistory extends BusinessObjectBase {
  static readonly entityName = 'UserTaskHistory' as const;
  static readonly plural = 'user-task-histories';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<UserTaskHistory[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new UserTaskHistory(data));
  }

  static async findOne(filter?: any): Promise<UserTaskHistory | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new UserTaskHistory(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<UserTaskHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new UserTaskHistory(data);
  }

  static async create(
    data: Omit<UserTaskHistoryData, 'id'>,
  ): Promise<UserTaskHistory> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new UserTaskHistory(result);
  }

  static async updateById(
    id: string,
    data: Partial<UserTaskHistoryData>,
  ): Promise<UserTaskHistory> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new UserTaskHistory(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
